import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const DOLLAR_FILTERS = [
  { key: 500, label: "$500+" },
  { key: 1000, label: "$1K+" },
  { key: 5000, label: "$5K+" },
  { key: 25000, label: "$25K+" },
];

const SIDE_FILTERS = [
  { key: "ALL", label: "All" },
  { key: "YES", label: "YES" },
  { key: "NO", label: "NO" },
];

const SORT_OPTIONS = [
  { key: "largest", label: "Largest" },
  { key: "newest", label: "Newest" },
  { key: "props_first", label: "Props First" },
  { key: "lines_first", label: "Lines First" },
];

// Matches services/kalshi/sport_classifier.py's ALL_FILTER_OPTIONS exactly -- a plain query
// against already-resolved/stored `sport_buckets`, never a new Kalshi API call.
const SPORT_FILTERS = [
  { key: "ALL", label: "All Sports" },
  { key: "Football", label: "Football" },
  { key: "Basketball", label: "Basketball" },
  { key: "Hockey", label: "Hockey" },
  { key: "Soccer", label: "Soccer" },
  { key: "Baseball", label: "Baseball" },
  { key: "Other", label: "Other Sports" },
  { key: "Non-sports", label: "Non-sports" },
];

export const BigMoneyFilters = ({
  minDollars,
  onMinDollarsChange,
  side,
  onSideChange,
  sort,
  onSortChange,
  sport,
  onSportChange,
  actionableOnly,
  onActionableOnlyChange,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <div data-testid="kalshi-dollar-filters" className="flex flex-wrap gap-2">
      {DOLLAR_FILTERS.map((f) => (
        <button
          key={f.key}
          type="button"
          data-testid={`kalshi-min-dollar-filter-${f.key}`}
          onClick={() => onMinDollarsChange(f.key)}
          className={`rounded-full border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
            minDollars === f.key ? "border-eb-accent bg-eb-accent/10 text-eb-accent" : "border-white/10 text-zinc-400 hover:text-zinc-200"
          }`}
        >
          {f.label}
        </button>
      ))}
    </div>
    <div data-testid="kalshi-sport-filter" className="flex items-center gap-2">
      <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Sport</span>
      <Select value={sport} onValueChange={onSportChange}>
        <SelectTrigger data-testid="kalshi-sport-filter-trigger" className="h-8 w-[150px] border-white/10 bg-transparent font-mono text-[11px] text-zinc-200">
          <SelectValue placeholder="All Sports" />
        </SelectTrigger>
        <SelectContent>
          {SPORT_FILTERS.map((s) => (
            <SelectItem key={s.key} value={s.key} data-testid={`kalshi-sport-option-${s.key}`} className="font-mono text-xs">
              {s.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <button
      type="button"
      data-testid="kalshi-actionable-only-toggle"
      onClick={() => onActionableOnlyChange(!actionableOnly)}
      aria-pressed={actionableOnly}
      className={`rounded-full border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
        actionableOnly ? "border-eb-accent bg-eb-accent/10 text-eb-accent" : "border-white/10 text-zinc-400 hover:text-zinc-200"
      }`}
    >
      Actionable &le; 75&cent; (-300)
    </button>
    <div data-testid="kalshi-side-filters" className="flex items-center gap-2">
      <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Side</span>
      {SIDE_FILTERS.map((s) => (
        <button
          key={s.key}
          type="button"
          data-testid={`kalshi-side-filter-${s.key}`}
          onClick={() => onSideChange(s.key)}
          className={`rounded-md border px-2.5 py-1 font-mono text-[11px] transition-colors ${
            side === s.key ? "border-eb-accent text-eb-accent" : "border-white/10 text-zinc-500 hover:text-zinc-300"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
    <div data-testid="kalshi-sort-controls" className="flex items-center gap-2">
      <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Sort</span>
      {SORT_OPTIONS.map((s) => (
        <button
          key={s.key}
          type="button"
          data-testid={`kalshi-sort-${s.key}`}
          onClick={() => onSortChange(s.key)}
          className={`rounded-md border px-2.5 py-1 font-mono text-[11px] transition-colors ${
            sort === s.key ? "border-eb-accent text-eb-accent" : "border-white/10 text-zinc-500 hover:text-zinc-300"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  </div>
);
